// MiniBoard.jsx — bulmaca listesindeki küçük, statik tahta önizlemesi (canvas'sız, hafif).
import React from 'react';
import { PIECE_NAMES, PROMOTED_NAMES } from '../lib/ShogiEngine';

export default function MiniBoard({ board }) {
  return (
    <div className="mini-board" aria-hidden="true">
      {board.flat().map((p, i) => (
        <div key={i} className="mb-cell">
          {p && (
            <span className={`mb-koma jp ${p.color === 'gote' ? 'gote' : ''} ${p.promoted ? 'promoted' : ''}`}>
              {(p.promoted ? PROMOTED_NAMES[p.type] : PIECE_NAMES[p.type])?.[0]}
            </span>
          )}
        </div>
      ))}
    </div>
  );
}
